// TODO add loading state when paginate replies
import { useMutation } from '@tanstack/react-query';
import PropTypes from 'prop-types';

import { getCommentRepliesList } from 'services/comment';

import RepliesPaginationLink from './RepliesPaginationLink';

const LoadMoreReplies = ({
  parentId,
  lastReplyId,
  appendRepliesAfterPagination,
}) => {
  const { mutate: mutateAddRepliesAfterPagination } = useMutation({
    mutationFn: getCommentRepliesList,
    onSuccess: (nextReplies, { commentId: parentCommentId }) => {
      appendRepliesAfterPagination(nextReplies, { parentCommentId });
    },
  });

  const onLoadMoreRepliesClick = () =>
    mutateAddRepliesAfterPagination({
      commentId: parentId,
      after: lastReplyId,
    });

  return (
    <RepliesPaginationLink
      onPaginate={() => onLoadMoreRepliesClick(parentId)}
    />
  );
};

LoadMoreReplies.propTypes = {
  parentId: PropTypes.number.isRequired,
  lastReplyId: PropTypes.arrayOf(PropTypes.number).isRequired,
  appendRepliesAfterPagination: PropTypes.func.isRequired,
};

export default LoadMoreReplies;
